import { Cookies } from "react-cookie";

/**
 * Returns the best candidate cookie value to use for the SSO
 * `loginFromCookie` endpoint.
 *
 * Priority:
 * 1. WordPress login cookie (wordpress_logged_in_*)
 * 2. GSA SSO key cookie (GSA_LOGIN_KEY)
 * 3. GSA SSO cookie (GSA_LOGIN)
 */
export const getSsoLoginCookie = (): string | undefined => {
  const cookies = new Cookies();
  const allCookies = cookies.getAll();

  // 1) WordPress login cookie (original flow)
  const wordpressCookieKey = Object.keys(allCookies).find(key => key.startsWith("wordpress_logged_in_"));
  if (wordpressCookieKey) {
    return allCookies[wordpressCookieKey];
  }

  // 2) GSA SSO cookies used by GAMBoD integration
  if (allCookies.GSA_LOGIN_KEY) {
    return allCookies.GSA_LOGIN_KEY;
  }

  if (allCookies.GSA_LOGIN) {
    return allCookies.GSA_LOGIN;
  }

  return undefined;
};

